import { useCallback, useState } from "react";
import { Button, Space, Typography } from "antd";
import { apiFetch } from "../../services/apiClient";
import type { FlujoFile } from "../flujos/flujos.api";
import { AdjuntosLavanderia } from "../lavanderia/components/AdjuntosLavanderia";
import type { MovimientoAseador } from "../../services/finanzas.api";

/** Carga solo bajo demanda, con URLs firmadas para quien consulta. */
export default function ComprobantesAsignacion({ movimiento }: { movimiento: MovimientoAseador }) {
  const [archivos, setArchivos] = useState<FlujoFile[] | null>(null);
  const [cargando, setCargando] = useState(false);
  const cargar = useCallback(async () => {
    if (!movimiento.asignacionId) return;
    setCargando(true);
    try {
      const r = await apiFetch<{ data: FlujoFile[] }>(`/finanzas/lavanderia-asignaciones/${movimiento.asignacionId}/archivos`, { errorMsg: "No se pudieron cargar los comprobantes." });
      if (r) setArchivos(r.data || []);
    } finally { setCargando(false); }
  }, [movimiento.asignacionId]);
  if (movimiento.origen !== "lavanderia_asignacion") return null;
  return <Space direction="vertical" size={2}>
    {archivos === null && <Button size="small" loading={cargando} onClick={() => void cargar()}>Ver comprobantes</Button>}
    {archivos && archivos.length === 0 && <Typography.Text type="secondary">Sin comprobantes</Typography.Text>}
    {archivos && archivos.length > 0 && <AdjuntosLavanderia grupos={[{ operacionId: movimiento.asignacionId!, movimiento: { id: movimiento.asignacionId!, tipo: "gasto_operacional", fecha: movimiento.fecha || "", descripcion: movimiento.descripcion || "Gasto de lavandería", monto: movimiento.monto }, archivos }]} actualizar={cargar} />}
  </Space>;
}
